<template>
  <div class="ym-no-record-com">
    <slot>暂无数据</slot>
  </div>
</template>

<script>
export default {
  name: 'no-record',
  data() {
    return {}
  },

  created() {

  },
  methods: {}
}
</script>

<style lang="scss">
.ym-no-record-com{
  /*width: 400px;*/
  text-align: center;
  padding: 30px;
  color:#999;
  font-size: 16px;
}
</style>
